import React, { Dispatch } from 'react';

// State
type AppState = {
  drawerOpen: boolean;
  // How many mounted pages/lazy sections are loading; the shell shows the
  // 3px bar under the App Bar while this is above 0
  routeLoadingCount: number;
  // Bumped by "Try again" on a page that didn't load, to remount it
  routeKey: number;
};
const initialState: AppState = {
  drawerOpen: false,
  routeLoadingCount: 0,
  routeKey: 0,
};

// Actions
type AppActions =
  | { type: 'TOGGLE_DRAWER' }
  | { type: 'DRAWER_CLOSE' }
  | { type: 'ROUTE_LOADING_START' }
  | { type: 'ROUTE_LOADING_END' }
  | { type: 'RETRY_ROUTE' };

const reducer = (state: AppState, action: AppActions) => {
  switch (action.type) {
    case 'TOGGLE_DRAWER': {
      return { ...state, drawerOpen: !state.drawerOpen };
    }
    case 'DRAWER_CLOSE': {
      return { ...state, drawerOpen: false };
    }
    case 'ROUTE_LOADING_START': {
      return { ...state, routeLoadingCount: state.routeLoadingCount + 1 };
    }
    case 'ROUTE_LOADING_END': {
      return {
        ...state,
        routeLoadingCount: Math.max(0, state.routeLoadingCount - 1),
      };
    }
    case 'RETRY_ROUTE': {
      return { ...state, routeKey: state.routeKey + 1 };
    }
    default: {
      return { ...state };
    }
  }
};

export const AppContext = React.createContext(
  {} as {
    state: AppState;
    dispatch: Dispatch<AppActions>;
  },
);

export function AppProvider(props: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {props.children}
    </AppContext.Provider>
  );
}
